const cadesSignature = {
  default: {
    title: 'Baixar documento em p7s',
    description: 'Tenho o documento assinado e quero baixar ele no formato p7s.',
  },
};

export default cadesSignature;
